import React from "react";
import Heading from "./components/Heading";
import Inspector from "./components/Inspector";
import "./inspector.scss";

function index() {
  return (
    <>
      <Heading />
      <Inspector />
    </>
  );
}

export default index;
